import { useLocation } from "react-router";
import Container from "@components/Container/Container";
import { IFRAME_URL_SRC } from "@routes/Content/utils/constants";
import { ENVIRONMENT } from "@util/constant";
import { addParamsToURL, getEnvironmentDomain } from "@util/helpers";
import IframeResizer from "iframe-resizer-react";

const ENVIRONMENT_DOMAIN = getEnvironmentDomain(ENVIRONMENT);

/**
 * This is the layout for the Advertise page.
 */
const AdvertiseLayout = (): React.ReactElement => {
  const { pathname, search, hash } = useLocation();
  const url = new URL(`${ENVIRONMENT_DOMAIN}${pathname}${search}${hash}`);
  const urlParams = new URLSearchParams(url.search);

  const utmParams = [
    { key: "utm_source", value: urlParams.get("utm_source") || "" },
    { key: "utm_medium", value: urlParams.get("utm_medium") || "" },
    { key: "utm_campaign", value: urlParams.get("utm_campaign") || "" },
    { key: "utm_term", value: urlParams.get("utm_term") || "" },
    { key: "utm_content", value: urlParams.get("utm_content") || "" },
  ];

  const advertisePageIframeUrl = addParamsToURL(
    IFRAME_URL_SRC,
    utmParams
  ).toString();

  const iframeResizerAttribs = {
    src: advertisePageIframeUrl,
    inPageLinks: true,
  };

  return (
    <div data-testid="advertise-layout-component">
      <Container rootClassName="pb-4">
        <h1 className="border-b border-gray-850 pb-3 pt-6 font-playfair text-8xl uppercase">
          ADVERTISE
        </h1>
      </Container>

      <div className="w-full" data-testid="advertise-component">
        <IframeResizer {...iframeResizerAttribs} className="w-full" />
      </div>
    </div>
  );
};

export default AdvertiseLayout;
